import { Injectable } from '@angular/core';
import { CoreApiService } from 'src/app/core/core-api.service';
import { CodigoTransacaoService } from 'src/app/shared/services/codigo-transacao.service';
import { endpoints } from 'src/environments/endpoints';

@Injectable({
  providedIn: 'root'
})
export class InsereEnderecoService {

  constructor(private apiService: CoreApiService, private codigo: CodigoTransacaoService) { }

  inserirEndereco(data){
    return this.apiService.post(endpoints.insereEndereco, data )
  }
}
